export default __webpack_public_path__ + "static/media/blur.5058f8ad.png";